import { FC, useState } from 'react';

import { useNotificationContext } from 'application/providers/NotificationProvider';
import { TEXTS } from 'application/pages/AdsPage/renderer/texts';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import { useMediaAdCampaignRenameMutation } from '@shared/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import Input, { InputType } from '@zvuk-b2b/react-uikit/ui/Input';

import { NOTIFICATIONS, NAME_MAX_LENGTH_ERROR } from '../consts';
import styles from './index.module.scss';

const AdRenameModal: FC<ModalProps[ModalTypes.AD_CAMPAIGN_RENAME]> = ({ id, title, close }) => {
  const notification = useNotificationContext();
  const [renameMutation, { loading }] = useMediaAdCampaignRenameMutation();

  const [prevId, setPrevId] = useState(id);
  const [name, setName] = useState(title);

  if (prevId !== id) {
    setPrevId(id);
    setName(title);
  }

  const isRenameButtonDisabled = loading || name.length === 0 || name === title;

  const onRename = async () => {
    try {
      const result = await renameMutation({ variables: { adCompanyId: id, title: name } });

      if (!result.data?.adcampaignRename?.adCompany) throw new Error();

      notification.showNotification(NOTIFICATIONS.RENAME_SUCCESS);
      close();
    } catch (error: any) {
      if (JSON.stringify(error).includes(NAME_MAX_LENGTH_ERROR)) {
        notification.showNotification(NOTIFICATIONS.MAX_LENGTH_ERROR);
      } else {
        notification.showNotification(NOTIFICATIONS.ERROR);
      }
    }
  };

  return (
    <ModalScreen
      title={TEXTS.MODAL_AD_RENAME_TITLE}
      titlePlacement="left"
      onClose={close}
      actionButtons={[
        <Button
          key="button_rename_ad_campaign_modal"
          elementId="button_rename_ad_campaign_modal"
          type={ButtonType.PRIMARY}
          isDisabled={isRenameButtonDisabled}
          onClick={onRename}
          isLoading={loading}>
          {TEXTS.MODAL_AD_RENAME_BUTTON_CONFIRM}
        </Button>,
      ]}>
      <Input
        elementId="input_rename-campaign"
        label={TEXTS.MODAL_AD_RENAME_INPUT_LABEL}
        isDisabled={loading}
        labelClassName={styles.label}
        type={InputType.TEXT}
        value={name}
        onChange={setName}
      />
    </ModalScreen>
  );
};

export default AdRenameModal;
